'use strict';

var Constants = require('../constants/constants')

// Constructor
var AccordionV2 = function () {
  var self = this

  self.config = {
    'button': $('[data-accordion-v2="toggle"]'),
  }

  var $buttonEl = self.config.button;

  self.clickHandler = function () {
    $buttonEl.each(function () {
      var $this = $(this);
      var $container = $('#'+$this.attr('aria-controls'));

      $this.on('click', new Constants().THROTTLE(function (e) {

        var activeState = function () {

          if ($this.attr('data-accordion-alt-text')) {
            self.altText($this)
          }
        }

        self.containerVisibility($container, $this, activeState)
      }, 300))
    })
  }

  self.containerVisibility = function ($container, $button, cb) {
    if ($container.hasClass('is-visible')) {
      self.hideContainer($container, $button, cb)
    } else {
      self.showContainer($container, $button, cb)
    }
  }

  self.altText = function ($button) {
    var oldText = $button.text();
    var newText = $button.attr('data-collapse-alt-text');

    $button.text(newText)
    $button.attr('data-collapse-alt-text', oldText)
  }

  self.showContainer = function ($container, $button, cb) {
    if (!$container.hasClass('is-visible') && !$container.hasClass('velocity-animating')) {
      var $stickySidebar = $('[data-sticky-sidebar]')

      if ($stickySidebar.length) {
        var $stickyParent = $('[data-sticky-sidebar]').parent()
        var fixHeight = $stickyParent.height()

        $stickyParent.css('height', fixHeight)
      }

      $button.addClass('is-active')
      $button.attr('aria-expanded', 'true')
      $container.addClass('is-visible')
      $container
        .velocity(
          'slideDown',
          {
            duration: 400,
            easing: 'easeOutQuart'
          }
        )
        .velocity(
          {
            opacity: '1'
          },
          {
            duration: 300,
            complete: function () {
              $button.attr('aria-expanded', 'true')

              if (typeof cb === 'function') {
                cb()
              }

              if ($stickySidebar.length) {
                $stickyParent.css('height', 'auto')
                $(document.body).trigger('sticky_kit:recalc')
              }
            }
          }
        )
    }
  }

  self.hideContainer = function ($container, $button, cb) {
    if ($container.hasClass('is-visible') && !$container.hasClass('velocity-animating')) {
      $button.removeClass('is-active')
      $button.attr('aria-expanded', 'false')
      $container.removeClass('is-visible')
      $container
        .velocity(
          {
            opacity: '0'
          },
          {
            duration: 200
          }
        )
        .velocity(
          'slideUp',
          {
            duration: 400,
            easing: 'easeOutQuart',
            complete: function () {
              $button.attr('aria-expanded', 'false')

              if (typeof cb === 'function') {
                cb()
              }

              $(document.body).trigger('sticky_kit:recalc')
            }
          }
        )
    }
  }

  self.init = function () {
    self.clickHandler()
  }
};

module.exports = AccordionV2;
